require('./reamenagement.scss');

import indexOf from 'lodash/indexOf';
import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';

export default class ReamenagementComponent {
  constructor() {
    this.controller = ReamenagementController;
    this.template = require('./reamenagement.html');
  }
}

// @ngInject
class ReamenagementController {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.Reamenagement));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.reamenagement ? state.demande.data.reamenagement.asMutable({deep: true}) : this.data,
          typePersonne: state.demande.data.typePersonne
        };
      }
    )(this);

    // Déconnexion du state à la suppression du Reamenagement
    this.$scope.$on('$destroy', disconnect);
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateReamenagement({}, true));
  }
  nextStep(source) {
    this.data.source = source;
    this.$ngRedux.dispatch(DemandeActions.updateReamenagement(this.data));
  }

  clickPhase(index) {
    let phase = angular.element(document.getElementsByName('phase-' + index));
    if (indexOf(phase[0].classList, 'open') === -1) {
      phase.addClass('open');
    } else {
      phase.removeClass('open');
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/accueil/components/reamenagement/reamenagement.component.js